/**
 * Calculadora de diluciones para productos de detailing
 * 
 * Personalización de David Conde
 * 
 * Metodología de cálculo:
 * - Para una dilución 1:X, el número X es el divisor del volumen total
 * - Ejemplo: 1:10 con 1000ml → Producto = 1000 ÷ 10 = 100ml, Agua = 900ml
 * - No es el método tradicional de "partes" (1 parte + X partes)
 * 
 * @see https://detailing.top/blogs/articulos/como-diluir-productos-detailing
 */

function calculateDilution() {
  // Obtener valores de los inputs
  const productRatio = parseFloat(document.getElementById("ratio-product").value);
  const waterRatio = parseFloat(document.getElementById("ratio-water").value);
  const totalVolume = parseFloat(document.getElementById("total-volume").value);

  // Validar que los valores sean correctos
  if (isNaN(productRatio) || isNaN(waterRatio) || isNaN(totalVolume) || totalVolume <= 0) {
    document.getElementById("result").innerHTML = "<p style='color: red;'>Por favor, introduce valores válidos.</p>";
    return;
  }

  // Validar que los ratios sean positivos
  if (productRatio <= 0 || waterRatio <= 0) {
    document.getElementById("result").innerHTML = "<p style='color: red;'>Los ratios deben ser mayores que 0.</p>";
    return;
  }

  // Calcular según la metodología donde waterRatio es el divisor del volumen total
  const totalParts = waterRatio; // El divisor (ej: 10 en una dilución 1:10)
  const productVolume = (totalVolume / totalParts) * productRatio; // Producto
  const waterVolume = totalVolume - productVolume; // Agua

  // Mostrar resultado
  document.getElementById("result").innerHTML = `
    <p><strong>Resultado:</strong></p>
    <p><strong>Cantidad de producto: ${productVolume.toFixed(2)} ml</strong></p>
    <p><strong>Cantidad de agua: ${waterVolume.toFixed(2)} ml</strong></p>
  `;
}

// Añadir event listener cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
  // Buscar el botón dentro del div de la calculadora
  const calculator = document.getElementById('dilution-calculator');
  if (calculator) {
    const button = calculator.querySelector('button[type="button"]');
    if (button) {
      button.addEventListener('click', calculateDilution);
    }
  }
});
